// Split a list of ids into request-sized batches so a mass action (e.g.
// delete-all over ~1,200 vouchers) stays well under the server body limit.
export const ID_CHUNK_SIZE = 500;

export const idChunks = (ids: string[], size = ID_CHUNK_SIZE): string[][] => {
   const chunks: string[][] = [];
   for (let i = 0; i < ids.length; i += size) {
      chunks.push(ids.slice(i, i + size));
   }
   return chunks;
};
